<template lang="pug">
  v-flex(xs12 :style="{position: 'fixed', height: 256 - offset + 'px', minHeight: '96px', top: offset <= 96 ? offset + 72 * (1-(offset/96)) + 'px' : ieTop+'px'}")#logo--holder
    v-avatar(color="white" :size="offset <= 96 ? 96 + 160 * (1-(offset/96)) : 96")
      v-img(alt="iamActive logo" :src="require('@/assets/logo.svg')" contain)#logo
</template>
<script>
export default {
  props: ["offset"],
  computed: {
    ieTop () {
      const ua = navigator.userAgent;
      const is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
      return is_ie ? 0 : this.offset
    }
  },
};
</script>
<style>
#logo {
  border-radius: 50%;
  border: 5px solid white;
  height: 100%;
  background: white;
}
#logo--holder {
  position: relative;
  width: 100%;
  z-index: 1;
  text-align: center;
  pointer-events: none;
}
</style>
